export default __webpack_public_path__ + "static/media/netherlands-flag.0cee6d75.png";